// Generated by TaroBase SDK Generator: 2026-05-01T17:36:41.366Z
// Collection: commonQueries/$queryId
// Edits may be overwritten by subsequent runs!

import {
  get, getMany, set, subscribe, getFiles, setFile, runQuery, count, aggregate, transformValues,
  Time, Token, Increment, Address, PublicKey,
  TimeOperation, IncrementOperation, TokenAmount, AddressType,
  TarobaseMetadata, DocumentOperation, FileItem, setMany, formatError,
} from '../db-client';
import type { AggregateResult, AggregateOperation } from '../db-client';

/**
 * Read-only queries for wallet balances and swap quotes. Supports SOL/USDC/SPL token balance lookups, Jupiter swap quotes, and Meteora dynamic bonding curve quotes.
 */

export interface CommonQueriesRequest {

}

export interface CommonQueriesResponse {

  id: string;
  tarobase_created_at: number;
}

/**
 * 
  Read Operation Details: Anyone can use these queries: (1) Balance queries - check SOL, USDC, or any SPL token balance for any wallet address. (2) Jupiter swap quotes - get expected output amounts for token swaps via Jupiter aggregator. (3) Meteora swap quotes - get expected output amounts for Meteora dynamic bonding curve pools.
   (Get Single Item)
 */
export async function getCommonQueries(queryId: string): Promise<CommonQueriesResponse | null> {
  try {
    const result = await get(`commonQueries/${queryId}`);
    return result as CommonQueriesResponse | null;
  } catch (error) {
    console.error(`Error getting CommonQueries: ${formatError(error)}`);
    return null;
  }
}

/**
 * Subscribes to changes in a single CommonQueries document. (
  Read Operation Details: Anyone can use these queries: (1) Balance queries - check SOL, USDC, or any SPL token balance for any wallet address. (2) Jupiter swap quotes - get expected output amounts for token swaps via Jupiter aggregator. (3) Meteora swap quotes - get expected output amounts for Meteora dynamic bonding curve pools.
  )
 */
export function subscribeCommonQueries(callback: (data: CommonQueriesResponse | null) => void, queryId: string): Promise<() => Promise<void>> {
  return subscribe(`commonQueries/${queryId}`, { // Use the item's basePath
    onData: (data) => {
      callback(data as CommonQueriesResponse | null);
    },
    onError: (error) => {
      console.error(`Error subscribing to CommonQueries at path '${`commonQueries/${queryId}`}': ${formatError(error)}`);
    }
  });
}

/**
 * Get many CommonQueries items from collection commonQueries
 
  Read Operation Details: Anyone can use these queries: (1) Balance queries - check SOL, USDC, or any SPL token balance for any wallet address. (2) Jupiter swap quotes - get expected output amounts for token swaps via Jupiter aggregator. (3) Meteora swap quotes - get expected output amounts for Meteora dynamic bonding curve pools.
  
 */
export async function getManyCommonQueries(filter: string = ""): Promise<CommonQueriesResponse[]> {
  try {
    const results = await get("commonQueries", { prompt: filter });
    return Array.isArray(results) ? results as CommonQueriesResponse[] : [];
  } catch (error) {
    console.error(`Error getting CommonQueries collection at path 'commonQueries': ${formatError(error)}`);
    return [];
  }
}

/**
 * Subscribe to changes in CommonQueries collection at commonQueries
 
  Read Operation Details: Anyone can use these queries: (1) Balance queries - check SOL, USDC, or any SPL token balance for any wallet address. (2) Jupiter swap quotes - get expected output amounts for token swaps via Jupiter aggregator. (3) Meteora swap quotes - get expected output amounts for Meteora dynamic bonding curve pools.
  
 */
export function subscribeManyCommonQueries(callback: (data: CommonQueriesResponse[]) => void, filter: string = ""): Promise<() => Promise<void>> {
  return subscribe("commonQueries", {
    prompt: filter,
    onData: (data) => {
      callback(Array.isArray(data) ? data as CommonQueriesResponse[] : []);
    },
    onError: (error) => {
       console.error(`Error subscribing to CommonQueries collection at path '${"commonQueries"}': ${formatError(error)}`);
    }
  });
}

/**
 * Get all CommonQueries items from collection commonQueries
 
  Read Operation Details: Anyone can use these queries: (1) Balance queries - check SOL, USDC, or any SPL token balance for any wallet address. (2) Jupiter swap quotes - get expected output amounts for token swaps via Jupiter aggregator. (3) Meteora swap quotes - get expected output amounts for Meteora dynamic bonding curve pools.
  
 */
export async function getAllCommonQueries(filter: string = ""): Promise<CommonQueriesResponse[]> {
  try {
    const results = await get("commonQueries", { prompt: filter });
    return Array.isArray(results) ? results as CommonQueriesResponse[] : [];
  } catch (error) {
    console.error(`Error getting CommonQueries collection at path 'commonQueries': ${formatError(error)}`);
    return [];
  }
}

/**
 * Subscribe to changes in CommonQueries collection at commonQueries
 
  Read Operation Details: Anyone can use these queries: (1) Balance queries - check SOL, USDC, or any SPL token balance for any wallet address. (2) Jupiter swap quotes - get expected output amounts for token swaps via Jupiter aggregator. (3) Meteora swap quotes - get expected output amounts for Meteora dynamic bonding curve pools.
  
 */
export function subscribeAllCommonQueries(callback: (data: CommonQueriesResponse[]) => void, filter: string = ""): Promise<() => Promise<void>> {
  return subscribe("commonQueries", {
    prompt: filter,
    onData: (data) => {
      callback(Array.isArray(data) ? data as CommonQueriesResponse[] : []);
    },
    onError: (error) => {
       console.error(`Error subscribing to CommonQueries collection at path '${"commonQueries"}': ${formatError(error)}`);
    }
  });
}

/**
 * Count CommonQueries items in collection commonQueries.
 * Returns a numeric count instead of fetching full documents — much more efficient.
 *
 * NOTE: This only works because the read policy for this collection is "true".
 * @param filter - Optional natural language filter (e.g., "created in the last 7 days")
 * @returns AggregateResult with the count value
 */
export async function countCommonQueries(filter: string = ""): Promise<AggregateResult> {
  try {
    return await count("commonQueries", { prompt: filter || undefined });
  } catch (error) {
    console.error(`Error counting CommonQueries at path 'commonQueries': ${formatError(error)}`);
    return { value: 0 };
  }
}

/**
 * Run an aggregate operation on CommonQueries items in collection commonQueries.
 * Returns a single numeric value instead of fetching full documents.
 *
 * Supported operations: 'count', 'uniqueCount', 'sum', 'avg', 'min', 'max'.
 * For 'sum', 'avg', 'min', 'max', and 'uniqueCount', you must provide the field name.
 *
 * NOTE: This only works because the read policy for this collection is "true".
 * @param operation - The aggregate operation to perform
 * @param opts - Options including optional filter prompt and field name
 * @returns AggregateResult with the computed numeric value
 */
export async function aggregateCommonQueries(operation: AggregateOperation, opts?: { filter?: string; field?: string }): Promise<AggregateResult> {
  try {
    return await aggregate("commonQueries", operation, { prompt: opts?.filter || undefined, field: opts?.field });
  } catch (error) {
    console.error(`Error aggregating CommonQueries at path 'commonQueries': ${formatError(error)}`);
    return { value: 0 };
  }
}

/** Arguments accepted by the "solBalance" query on CommonQueries. */
interface CommonQueriesSolBalanceArgs {
  walletAddress: string;
}

/**
 * Runs the "solBalance" query on CommonQueries.
 * Description: Get SOL balance for a wallet address in lamports (1 SOL = 1,000,000,000 lamports). Pass walletAddress as parameter.
 * Query Logic: @TokenPlugin.getBalance(@newData.walletAddress, @constants.SOL)
 */
export async function runSolBalanceQueryForCommonQueries(queryId: string, args: CommonQueriesSolBalanceArgs): Promise<number> {
  try {
    const result = await runQuery(`commonQueries/${queryId}`, "solBalance", args);
    return result as number;
  } catch (error) {
    console.error(`Error running query "solBalance" on CommonQueries: ${formatError(error)}`);
    throw error;
  }
}

/** Arguments accepted by the "usdcBalance" query on CommonQueries. */
interface CommonQueriesUsdcBalanceArgs {
  walletAddress: string;
}

/**
 * Runs the "usdcBalance" query on CommonQueries.
 * Description: Get USDC balance for a wallet address in base units (1 USDC = 1,000,000 base units with 6 decimals). Pass walletAddress as parameter.
 * Query Logic: @TokenPlugin.getBalance(@newData.walletAddress, @constants.USDC)
 */
export async function runUsdcBalanceQueryForCommonQueries(queryId: string, args: CommonQueriesUsdcBalanceArgs): Promise<number> {
  try {
    const result = await runQuery(`commonQueries/${queryId}`, "usdcBalance", args);
    return result as number;
  } catch (error) {
    console.error(`Error running query "usdcBalance" on CommonQueries: ${formatError(error)}`);
    throw error;
  }
}

/** Arguments accepted by the "tokenBalance" query on CommonQueries. */
interface CommonQueriesTokenBalanceArgs {
  walletAddress: string;
  tokenMint: string;
}

/**
 * Runs the "tokenBalance" query on CommonQueries.
 * Description: Get balance for any SPL token mint for a wallet address. Pass walletAddress and tokenMint as parameters. Returns balance in the token's smallest units based on its decimals.
 * Query Logic: @TokenPlugin.getBalance(@newData.walletAddress, @newData.tokenMint)
 */
export async function runTokenBalanceQueryForCommonQueries(queryId: string, args: CommonQueriesTokenBalanceArgs): Promise<number> {
  try {
    const result = await runQuery(`commonQueries/${queryId}`, "tokenBalance", args);
    return result as number;
  } catch (error) {
    console.error(`Error running query "tokenBalance" on CommonQueries: ${formatError(error)}`);
    throw error;
  }
}

/** Arguments accepted by the "jupiterSwapQuote" query on CommonQueries. */
interface CommonQueriesJupiterSwapQuoteArgs {
  inputMint: string;
  outputMint: string;
  amount: string;
}

/**
 * Runs the "jupiterSwapQuote" query on CommonQueries.
 * Description: Get a Jupiter swap quote for exchanging tokens. Pass inputMint (token to sell, use @constants.SOL for native SOL), outputMint (token to buy), and amount (in smallest units like lamports). Returns the expected output amount.
 * Query Logic: @DeFiPlugin.getSwapQuote(@newData.inputMint, @newData.outputMint, @newData.amount)
 */
export async function runJupiterSwapQuoteQueryForCommonQueries(queryId: string, args: CommonQueriesJupiterSwapQuoteArgs): Promise<number> {
  try {
    const result = await runQuery(`commonQueries/${queryId}`, "jupiterSwapQuote", args);
    return result as number;
  } catch (error) {
    console.error(`Error running query "jupiterSwapQuote" on CommonQueries: ${formatError(error)}`);
    throw error;
  }
}

/** Arguments accepted by the "meteoraSwapQuote" query on CommonQueries. */
interface CommonQueriesMeteoraSwapQuoteArgs {
  tokenMintAddress: string;
  tokenToSwapInMintAddress: string;
  tokenAmount: string;
}

/**
 * Runs the "meteoraSwapQuote" query on CommonQueries.
 * Description: Get a Meteora dynamic bonding curve swap quote. Pass tokenMintAddress (the pool's base token), tokenToSwapInMintAddress (token to swap in, use @constants.SOL for native SOL), and tokenAmount (in smallest units). Returns the expected output amount.
 * Query Logic: @DeFiPlugin.getMeteoraSwapQuote(@newData.tokenMintAddress, @newData.tokenToSwapInMintAddress, @newData.tokenAmount)
 */
export async function runMeteoraSwapQuoteQueryForCommonQueries(queryId: string, args: CommonQueriesMeteoraSwapQuoteArgs): Promise<number> {
  try {
    const result = await runQuery(`commonQueries/${queryId}`, "meteoraSwapQuote", args);
    return result as number;
  } catch (error) {
    console.error(`Error running query "meteoraSwapQuote" on CommonQueries: ${formatError(error)}`);
    throw error;
  }
}

